<template>
    <div class="az-content-header d-block d-md-flex">
        <div v-if='isBO'>
          <h2 class="az-content-title tx-20 mg-b-15 mg-b-lg-8">{{brand}}</h2>
          <p class="mg-b-0 tx-12"><router-link to='/businessoverview/'>Business Overview</router-link> / <router-link :to='"/adviserdashboard/"'> Adviser Dashboard</router-link> / {{$route.query.page}}</p>
        </div>
        <div v-else>
          <div v-if='!hiInfo'>
            <h2 class="az-content-title tx-20 mg-b-15 mg-b-lg-8">{{brand}}</h2>
            <p class="mg-b-0 tx-12"><router-link :to='"/adviserdashboard/"'> Adviser Dashboard</router-link> / {{$route.query.page}}</p>
          </div>
          <div v-else>
            <h2 class="az-content-title tx-24 mg-b-5 mg-b-lg-8">Hi, {{isSample?'Sample User':firstname}}</h2>
            <p class="mg-b-0 tx-13">Here's your adviser dashboard for <strong>{{isSample?'Sample Pty Ltd':brand}}</strong>.</p>
          </div>
        </div>
        <div class="az-dashboard-header-right">
            <div class="media az-media-date">
              <h1 style="font-size: 34px;">{{dd}}</h1>
              <div class="media-body">
                <p style="font-size: 12px;">{{mm}} {{yy}}</p>
                <span style="font-size: 12px;float: left;">{{ww}}</span>
              </div>
            </div>
            <!-- <div style="margin-left: 20px;">
              <a onclick="calendarControl()" class="btn btn-icon" style="background-color: #e3e7ed;">
                <i class="typcn typcn-calendar-outline tx-24 lh--9 op-6"></i>
              </a>
            </div> -->
        </div><!-- az-dashboard-header-right -->
    </div><!-- az-content-header -->
</template>
<script>
export default {
  name: 'Adviserinfo',
  props: {
    
  },
  data(){
    return{
      hiInfo:true,
      isSample:false,
      isBO: false,
      firstname:'',
      brand:'',
      dd:'',
      mm:'',
      yy:'',
      ww:'',
    }
  },
  watch:{
    $route: function(newVal){
      if('page' in newVal.query){
          this.hiInfo = false
      }else{
          this.hiInfo = true
      }
    }
  },
  created() {
    this.getInfo();
    this.getDate();
  },
  methods:{
    getInfo: function(){
      const userdetail = JSON.parse(localStorage.getItem('userdetail'));
      this.firstname = userdetail['firstname'];
      this.isBO = userdetail['isBO'];
      this.brand = localStorage.getItem('brand_name')
      this.isSample = userdetail['sample'];
    },
    getDate: function(){
      let date = new Date();
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun","Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
      const weekdays = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]
      let dd = date.getDate();
      if(dd<10){
        this.dd = '0'+dd;
      }else{
        this.dd = dd;
      }
      this.mm = monthNames[date.getMonth()];
      this.yy = date.getFullYear();
      this.ww = weekdays[date.getDay()];
    },
    
  }
  
}
</script>

  